// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

/**
 * Returns an error jsx element
 *
 * @returns react element
 */
export default function AppCrash(): JSX.Element {
  return (
    <div className="error-404-page">
      <h1>The App has crashed, sorry :(</h1>
      <h3>Something went wrong!</h3>
      <h3>Reload the window to continue!</h3>
    </div>
  );
}
